import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { TooltipOptions } from "primereact/tooltip/tooltipoptions";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { STUDENT_TRAIT_AND_TOTAL_SCORES } from "../../student/performance/PerformanceReport";
import { formatNumber, formatNumberOneDecimal } from "../../shared/reportUtil";
import { studentPerformanceLink } from "./PerformanceReport";
import { WriterEssayTraitScore, EssayTraitScore } from "./ScoresFilteredByCourseViewModel";

export function EssayTraitScoreTable(props: {
	className: string;
	courseId: number;
	writerData: WriterEssayTraitScore[];
	classData: EssayTraitScore;
}) {
	const hasData = props.writerData && props.writerData.length > 0;
	const tooltipOptions: TooltipOptions = {
		position: "top",
		showDelay: 250,
		hideDelay: 0,
	};

	const studentNameTemplate = (rowData: WriterEssayTraitScore) => {
		return (
			<Link
				className="link"
				to={studentPerformanceLink(props.courseId, rowData.writerId)}
				state={{ section: STUDENT_TRAIT_AND_TOTAL_SCORES }}>
				{rowData.writerName}
			</Link>
		);
	};

	const textualEvidenceTemplate = (rowData: WriterEssayTraitScore) => {
		return formatNumber(rowData.textualEvidenceScore);
	};

	const contentAccuracyTemplate = (rowData: WriterEssayTraitScore) => {
		return formatNumber(rowData.contentAccuracyScore);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Class" footerClassName="font-medium !text-right !pr-6" />
				<Column
					footer={formatNumberOneDecimal(props.classData.developmentOfIdeasScore)}
					footerClassName="font-medium !px-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.organizationScore)}
					footerClassName="font-medium !px-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.styleScore)}
					footerClassName="font-medium !px-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.wordChoiceScore)}
					footerClassName="font-medium !px-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.sentenceStructureScore)}
					footerClassName="font-medium !px-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.conventionsScore)}
					footerClassName="font-medium !p-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.totalScore)}
					footerClassName="font-medium !px-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.textualEvidenceScore)}
					footerClassName="font-medium !px-2"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.contentAccuracyScore)}
					footerClassName="font-medium !px-2"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<>
			<DataTable
				value={props.writerData}
				dataKey="writerId"
				loading={props.writerData == undefined}
				emptyMessage="No results found"
				stripedRows
				sortIcon={CustomSortIcon}
				className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
				footerColumnGroup={hasData && footerGroup}>
				<Column
					header="Student"
					body={studentNameTemplate}
					sortable
					sortField="writerName"></Column>
				<Column
					header="Dev"
					field="developmentOfIdeasScore"
					sortable
					headerTooltip="Development of Ideas"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="Org"
					field="organizationScore"
					sortable
					headerTooltip="Organization"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="Style"
					field="styleScore"
					sortable
					headerTooltip="Style"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="WC"
					field="wordChoiceScore"
					sortable
					headerTooltip="Word Choice"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="Sent"
					field="sentenceStructureScore"
					sortable
					headerTooltip="Sentence Structure"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="Conv"
					field="conventionsScore"
					sortable
					headerTooltip="Conventions"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="Total"
					field="totalScore"
					sortable
					headerTooltip="Total Score"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="Text"
					body={textualEvidenceTemplate}
					sortable
					sortField="textualEvidenceScore"
					headerTooltip="Textual Evidence"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
				<Column
					header="Cont"
					body={contentAccuracyTemplate}
					sortable
					sortField="contentAccuracyScore"
					headerTooltip="Content Accuracy"
					headerTooltipOptions={tooltipOptions}
					headerClassName="!px-2"
					className="!px-2"></Column>
			</DataTable>
		</>
	);
}
